// const BASE_URL = "https://localhost:44370/api";
const BASE_URL = "https://buypolicynow.com/foundation/api";

// export const PospLoginLink="http://20.244.35.226/BuyPolicyNow-Posp/posp/login"
export const PospLoginLink="https://buypolicynow.com/POSP/login"

const apiUrls = {
   InsertPOSPMaster: `${BASE_URL}/POSPMaster/InsertPOSPMaster`,

   ////////////POSP REGESTRATION////////////////
   GetGenderDropDown: `${BASE_URL}/POSPMaster/GetGenderDropDown`,
   GetCourseDropDown: `${BASE_URL}/POSPMaster/GetCourseDropDown`,
   GetStateDropDown: `${BASE_URL}/POSPMaster/GetStateDropDown`,
   GetCityDropDown: `${BASE_URL}/POSPMaster/GetCityDropDown`,
   GetPincodeDropDown: `${BASE_URL}/POSPMaster/GetPincodeDropDown`,
   GetBankNameDropDown: `${BASE_URL}/POSPMaster/GetBankNameDropDown`,
   GetRelationshipDropDown: `${BASE_URL}/POSPMaster/GetRelationshipDropDown`,
   GetPOSPMasterByID: `${BASE_URL}/POSPMaster/GetPOSPMasterByID`,
   UpdateInsertPOSP: `${BASE_URL}/POSPMaster/UpdateInsertPOSP`,
   GetPincodeDropDownList: `${BASE_URL}/POSPMaster/GetPincodeDropDownList`,
   GetStateCityPincodeByPincodeID: `${BASE_URL}/POSPMaster/GetStateCityPincodeByPincodeID`,
 /////////////////////// POSP Request Master ////////////////
 InsertPOSPRequestMaster: `${BASE_URL}/POSPRequestMaster/InsertPOSPRequestMaster`,
 GetPOSPRequestMaster: `${BASE_URL}/POSPRequestMaster/GetPOSPRequestMaster`,
 UpdatePOSPRequestMaster: `${BASE_URL}/POSPRequestMaster/UpdatePOSPRequestMaster`,

   /////////////////////// Bike Registration form  ////////////////
   GetMakeDropDown: `${BASE_URL}/MotorProposal/GetMakeDropDownByName`,
   GetModelDropDown: `${BASE_URL}/MotorProposal/GetModelDropDown`,
   GetVariantDropDown: `${BASE_URL}/MotorProposal/GetVariantMaster`,
   GetFuelTypeDropDown: `${BASE_URL}/MotorProposal/GetFuelTypeDropDown`,
   GetRtoDropDown: `${BASE_URL}/MotorProposal/GetRTODropDown`,
   InsertLeadMaster: `${BASE_URL}/MotorProposal/InsertLeadMaster`,
   GetStateDropDownMotor: `${BASE_URL}/MotorProposal/GetStateDropDown`,
   GetCityDropDownMotor: `${BASE_URL}/MotorProposal/GetCityDropDown`,
   GetPincodeDropDownMotor: `${BASE_URL}/MotorProposal/GetPincodeDropDown`,
   GetBankNameDropDownMotor: `${BASE_URL}/MotorProposal/GetBankNameDropDown`,  // banlk
   InsertCustomerProposal: `${BASE_URL}/MotorProposal/InsertCustomerProposal`,
   GetLeadMasterByID: `${BASE_URL}/MotorProposal/GetLeadMasterByID`,
   GetInsurerMasterDropDown: `${BASE_URL}/MotorProposal/GetInsurerMasterDropDown`,
   GetVehicleDetails: `${BASE_URL}/MotorProposal/GetVehicleDetails`,
   GetProductDropDown: `${BASE_URL}/MotorProposal/GetProductDropDown`,
   GetNCB: `${BASE_URL}/MotorProposal/GetNCB`,
   PoliciesGen: `${BASE_URL}/MotorProposal/PoliciesGen`,

   
   //Login

}

export default apiUrls